export const StepType = {
    MAIN_TEXT : "본문",
    LISTENING : "Listening",
    SENTENCE : "Sentence",
    HEARING : "Hearing",
    DIALOGUE : "Dialogue",
    WRITING : "Writing",
    SPEAKING : "Speaking",
}
export const WorkType = {
    COORDINATION : "좌표",
    TRANSLATION : "번역",
    QUIZ : "Quiz",
    MEMORIZATION : "Memorization",
    HEARING : "듣기",
    CONVERSATION : "대화 생성",
}
export const getWorkType = (type) => {
    return `(${type})`
}

export const ContentCompleteOrder = {
    completedFirstContent : "completedFirstContent",
    completedSecondContent : "completedSecondContent",
    completedThirdContent : "completedThirdContent",
    completedFourthContent : "completedFourthContent",
    completedFifthContent : "completedFifthContent",
    completedSixthContent : "completedSixthContent",
    completedSeventhContent : "completedSeventhContent",
}


export const ODD_STEPS = [
    {
        text: StepType.MAIN_TEXT,
        step: 1,
        completedFirstContent: false,
    },
    {
        text: StepType.LISTENING + getWorkType(WorkType.COORDINATION),
        step: 2,
        completedSecondContent: false,
    },
    {
        text: StepType.LISTENING  + getWorkType(WorkType.TRANSLATION),
        step: 3,
        completedThirdContent: false,
    },
    {
        text: StepType.LISTENING  + getWorkType(WorkType.QUIZ),
        step: 4,
        completedFourthContent: false,
    },
    {
        text: StepType.SENTENCE,
        step: 5,
        completedFifthContent: false,
    },
    {
        text: StepType.HEARING + getWorkType(WorkType.HEARING),
        step: 6,
        completedSixthContent: false,
    },
    {
        text: StepType.HEARING + getWorkType(WorkType.MEMORIZATION),
        step: 7,
        completedSeventhContent: false,
    }];






export const EVEN_STEPS = [
    {
        text: StepType.DIALOGUE + getWorkType(WorkType.CONVERSATION),
        step: 1,
        completedFirstContent: false,
    },
    {
        text: StepType.DIALOGUE + getWorkType(WorkType.TRANSLATION),
        step: 2,
        completedSecondContent: true,
    },
    {
        text: StepType.WRITING + getWorkType(WorkType.QUIZ),
        step: 3,
        completedThirdContent: false,
    },
    {
        text: StepType.WRITING,
        step: 4,
        completedFourthContent: false,
    },
    {
        text: StepType.WRITING + getWorkType(WorkType.TRANSLATION),
        step: 5,
        completedFifthContent: false,
    },
    {
        text: StepType.SPEAKING,
        step: 6,
        completedSixthContent: false,
    },
    {
        text: StepType.SPEAKING + getWorkType(WorkType.TRANSLATION),
        step: 7,
        completedSeventhContent: false,
    }];

export const DayType = {
    ODD: "ODD",
    EVEN: "EVEN",
}
